import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { BiBed, BiBath, BiArea } from 'react-icons/bi';
import { useToken } from '../contex/TokenProvider';
import {TiTimes} from 'react-icons/ti';
import { TiArrowBackOutline } from "react-icons/ti";
import BaseUrl from '../api/BaseUrl';

function ViewProperties() {
const [data, setData] = useState([]);
  
const navigate = useNavigate();
const {token} = useToken();

const {id} = useParams();
  
useEffect(() => {  
  BaseUrl.get(`/Property/get-property/${id}`, {  
    headers: {  
      'Authorization': `Bearer ${token}`  
    }  
  })  
  .then(res => setData(res.data.data))  
  .catch(err => console.log(err));   
  
}, [token, id]); 

  return (
    <div className='py-[150px] mx-[100px]'>
      <div className='bg-slate-100 py-10 px-10 mx-auto rounded-md shadow-md'>
        <div className='px-10'>
          <h1 className='font-bold text-[30px] text-gray-700 mb-10 text-center'>{data.title}</h1>
        </div>
        <div className='flex flex-row gap-10 items-center justify-center'>
          <div className='w-[400px] shadow-lg rounded-bl-[50px]'>
            <img className='w-[100%] rounded-tr-[50px] rounded-bl-[50px]' src={data.image}  alt={data.image} />
          </div>

          <div className='flex flex-col gap-5'>
            <h1 className='text-[25px] font-bold text-gray-700'>{data.state}</h1>
            <p className=' border-b-[4px]'><span className='text-[18px] text-gray-700 font-semibold'>Description:</span> {data.description}</p>
            <p className=' border-b-[4px]'><span className='text-[18px] text-gray-700 font-semibold'>Address:</span> {data.address}</p>
            <p className=' border-b-[4px]'><span className='text-[18px] text-gray-700 font-semibold'>Type of Property:</span> {data.type}</p>
            <p className='text-[20px] font-bold text-gray-700 border-b-[4px]'><span>Price:</span> {data.price}</p>
            
            <div className='flex flex-row gap-5 border-b-[4px]'>
              <div className='flex flex-row gap-2'>
                <BiBed />
                <p>{data.bedrooms}</p>
              </div>
              <div className='flex flex-row gap-2'>
                <BiBath />
                <p>{data.bathrooms}</p>
              </div>
              <div className='flex flex-row gap-2'>
                <BiArea />
                <p>{data.surface}</p>
              </div>
            </div>

            <div className='flex flex-row gap-2'>
              <Link to={`/editproperties/${data.id}`} className='px-4 py-2 rounded-md bg-green-500 text-white font-bold'>Edit</Link>
              <Link to={'/properties'} className='px-4 py-2 rounded-md bg-red-500 text-white font-bold'>Back</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewProperties
